<div class="chat-container mat-elevation-z8">
    <div class="chat-header">
        <button type="button" class="m-2" (click)="initConversation()" mat-raised-button>New Conversation</button>
        <button type="button" class="m-2" (click)="copyChatbotCode()" color="primary" mat-raised-button>Copy Code</button>
    </div>
    <div class="chat-log">
        <div class="message-container" *ngFor="let message of messages">
            <div class="message" [ngClass]="{
                'sent': message.role=='user',
                'received': message.role=='assistant'
                }" [innerHTML]="message.content">
            </div>
            <br>
           
        </div>
        <div *ngIf="isLoading" class="message-container">
            <div  class="message received typing-animation">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
            </div>
        </div>

    </div>
    <div class="chat-form">
        <textarea type="text" [(ngModel)]="query" placeholder="Type your message..."></textarea>
        <button (click)="answer()" [disabled]="query.length == 0" matSuffix mat-icon-button aria-label="Ask">
            <mat-icon>send</mat-icon>
        </button>
    </div>
    <div>
        <p class="powered-by"> Powered by: https://pulsyai.com/</p>
    </div>
</div>